import { object, string, bool } from '~utils/validation';
import { parseCurrencyStringToNumber } from '~utils/formatters';

export default object({
  isAllFieldsVisible: bool(),
  cnpj: string().max(18).required(),
  tradingName: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().max(100).required(),
  }),
  zipCode: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().required().zipCode(),
  }),
  street: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().max(40).required(),
  }),
  number: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string()
      .required()
      .max(6)
      .positiveNumber('número deve ser maior ou igual a 1 (um).'),
  }),
  neighborhood: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().max(40).required(),
  }),
  state: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().required(),
  }),
  city: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().required(),
  }),
  complement: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string().max(30).optional(),
  }),
  revenue: string().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: string()
      .max(22)
      .test(
        'positive-number',
        'número deve ser maior ou igual a 1 (um).',
        (value) => parseCurrencyStringToNumber(value) >= 1
      )
      .test(
        'less-than-100-trillion',
        'O faturamento anual excedeu o limite máximo permitido',
        (value) => parseCurrencyStringToNumber(value) <= 100_000_000_000_000
      )
      .required(),
  }),
  terms: bool().when('isAllFieldsVisible', {
    is: (isAllFieldsVisible: boolean) => isAllFieldsVisible,
    then: bool().oneOf([true], 'Campo obrigatório'),
  }),
});
